var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('agent-info-comp'),_c('agent-sub-title',[_vm._v("에이전트 리스트,손이익,롤링정보")]),_c('div',{staticClass:"data"},[_c('div',{staticStyle:{"margin":"10px 0","text-align":"center","width":"100%"}}),_c('agent-recursion-comp2',{attrs:{"list":_vm.agentList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }